/* istanbul ignore file */
export const QueryKey = {
  Agents: ["agents"],
  ExecutableRules: ["executable-rules"],
  ExecutableRulesById: ["executable-rules", "by-id"],
  ExecutableRulesUpdate: ["executable-rules", "update"],
  HrUpload: ["hr-upload"],
  HrUploadFile: ["hr-upload-file"],
  Logs: ["logs"],
  Notifications: ["notifications"],
  NotificationsSetAsRead: ["notifications", "set-as-read"],
  PeriodicRules: ["periodic-rules"],
  PeriodicRulesById: ["periodic-rules", "by-id"],
  PeriodicRulesUpdate: ["periodic-rules", "update"],
  PeriodicTasks: ["periodic-tasks"],
  PeriodicTasksById: ["periodic-tasks", "by-id"],
  PeriodicTasksStart: ["periodic-tasks", "start"],
  PeriodicTasksComplete: ["periodic-tasks", "start"],
  RemediationTasks: ["remediation-tasks"],
  RemediationTasksById: ["remediation-tasks", "by-id"],
  RemediationTasksApprove: ["remediation-tasks", "approve"],
  RemediationTasksReject: ["remediation-tasks", "reject"],
  StatisticsCompliancy: ["statistics-compliancy"],
  StatisticsTaskTotals: ["statistics-task-totals"],
} as const;
